module.exports = __webpack_public_path__ + "img/list3.8548b250.png";